module.exports = __webpack_public_path__ + "img/newDetail_zbhl3.ed02323d.png";